module.exports = __webpack_public_path__ + "img/har_yes.5e085bc3.png";